import { Button } from "reactstrap";
import BottyAI from "src/modules/data-protection/assets/images/ai-botty/failed.png";

const FailedStep = ({ t, onRetry }) => (
  <div className="text-center">
    <img className="mt-5 mb-3" src={BottyAI} width="50%" height="50%" alt="Botty" />

    <h6 className="my-5">
      {t("Our AI cannot receive a response from the source. Please try again.")}
    </h6>

    <div className="mb-4">
      <Button color="primary" onClick={onRetry}>
        {t("Try again")}
      </Button>
    </div>
  </div>
);

export default FailedStep;
